var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import TaskOutlinedIcon from "@mui/icons-material/TaskOutlined";
import { Dialog, DialogContent, DialogTitle, IconButton, Stack, Typography, Button, } from "@mui/material";
import { Colors } from "../util/theme";
export var ViewPdf = function (_a) {
    var isOpen = _a.isOpen, close = _a.close, base64 = _a.base64, title = _a.title;
    var _b = useState(isOpen), isModalOpen = _b[0], setIsModalOpen = _b[1];
    var downloadPDF = function () {
        // Converte a string Base64 para um array de bytes
        var byteCharacters = atob(base64);
        var byteNumbers = Array.from(byteCharacters, function (char) {
            return char.charCodeAt(0);
        });
        var byteArray = new Uint8Array(byteNumbers);
        // Cria um Blob a partir do array de bytes
        var blob = new Blob([byteArray], { type: "application/pdf" });
        // Cria um link de download temporário
        var url = URL.createObjectURL(blob);
        var link = document.createElement("a");
        link.href = url;
        link.download = "documento.pdf";
        document.body.appendChild(link);
        link.click();
        // Limpa o link temporário após o download
        link.remove();
        URL.revokeObjectURL(url);
    };
    return (_jsxs(Dialog, __assign({ open: isModalOpen, onClose: function () { return close(); }, fullWidth: true, maxWidth: base64 ? "xl" : "sm" }, { children: [_jsxs(DialogTitle, __assign({ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }, { children: [_jsxs(Stack, __assign({ direction: "row", alignItems: "center", gap: "1rem" }, { children: [_jsx(Stack, __assign({ bgcolor: Colors.AZUL_GOV, borderRadius: "50%", p: "0.5rem" }, { children: _jsx(TaskOutlinedIcon, { fontSize: "large", sx: { color: "white" } }) })), _jsx(Typography, __assign({ variant: "h6" }, { children: title })), _jsx(Button, __assign({ onClick: downloadPDF, variant: "contained" }, { children: "Baixar" }))] })), _jsx(IconButton, __assign({ onClick: function () {
                            setIsModalOpen(false);
                            close();
                        } }, { children: _jsx(CloseIcon, {}) }))] })), _jsx(DialogContent, { children: _jsx("iframe", { src: "data:application/pdf;base64,".concat(base64), width: "100%", height: "800px", style: { border: "none" }, title: "Formul\u00E1rio Renach" }) })] })));
};
